import { Component } from '@angular/core';

@Component({
  selector: 'ui-list-thumbnail',
  templateUrl: './list-thumbnail.component.html'
})
export class ListThumbnailComponent {
}